
import { LOCALE, t } from "@shared/i18n";
/** Formatage de dates dans le fuseau de l'utilisateur (profil). */
let TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const setUserTimezone = (tz: string) => {
  TZ = tz;
};
export const userTz = () => TZ;

const fmt = (d: Date | string, o: Intl.DateTimeFormatOptions) => new Intl.DateTimeFormat(LOCALE, { timeZone: TZ, ...o }).format(typeof d === "string" ? new Date(d) : d);
export const fmtTime = (d: Date | string) => fmt(d, { hour: "2-digit", minute: "2-digit" });
export const fmtDay = (d: Date | string) => fmt(d, { weekday: "short", day: "numeric", month: "short" });
export const fmtDayLong = (d: Date | string) => fmt(d, { weekday: "long", day: "numeric", month: "long" });
export const fmtDateTime = (d: Date | string) => fmt(d, { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

/** Parties locales d'une date dans le fuseau utilisateur. */
export function parts(d: Date | string) {
  const p = new Intl.DateTimeFormat("en-US", { timeZone: TZ, hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", weekday: "short" }).formatToParts(typeof d === "string" ? new Date(d) : d);
  const g = (t: string) => p.find((x) => x.type === t)?.value ?? "";
  return { y: Number(g("year")), m: Number(g("month")), d: Number(g("day")), h: Number(g("hour")), min: Number(g("minute")), wd: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].indexOf(g("weekday")) };
}

/** Clé AAAA-MM-JJ locale. */
export const dayKey = (d: Date | string) => {
  const p = parts(d);
  return `${p.y}-${String(p.m).padStart(2, "0")}-${String(p.d).padStart(2, "0")}`;
};

/** Valeur pour <input type="datetime-local"> (heure locale utilisateur, sans fuseau : le serveur l'interprète dans le fuseau du profil). */
export const toLocalInput = (d: Date | string | null) => {
  if (!d) return "";
  const p = parts(d);
  return `${dayKey(d)}T${String(p.h).padStart(2, "0")}:${String(p.min).padStart(2, "0")}`;
};
export const toDateInput = (d: Date | string | null) => (d ? dayKey(d) : "");

/** Ajoute n jours à une clé AAAA-MM-JJ. */
export const addDays = (key: string, n: number) => {
  const [y, m, d] = key.split("-").map(Number);
  const x = new Date(Date.UTC(y, m - 1, d + n));
  return x.toISOString().slice(0, 10);
};
export const weekdayOfKey = (key: string) => new Date(`${key}T12:00:00Z`).getUTCDay();

export function relativeDue(iso: string | null) {
  if (!iso) return null;
  const today = dayKey(new Date());
  const k = dayKey(iso);
  if (k === today) return { label: t("Aujourd'hui"), tone: "warning" as const };
  if (k < today) return { label: t("En retard · {0}", fmtDay(iso)), tone: "accent" as const };
  if (k === addDays(today, 1)) return { label: t("Demain"), tone: "neutral" as const };
  return { label: fmtDay(iso), tone: "neutral" as const };
}

export const minutesLabel = (m: number | null | undefined) => (m == null ? "" : m < 60 ? `${m} min` : `${Math.floor(m / 60)} h${m % 60 ? ` ${String(m % 60).padStart(2, "0")}` : ""}`);
